import React from 'react';
import PropTypes from 'prop-types';

function Loader({ className, isLarge, wrapperClass }) {
  return (
    <div className={wrapperClass}>
      <div className={`loader loader--${isLarge ? 'large' : 'small'} ${className || ''}`}>
        &nbsp;
      </div>
    </div>
  );
}

Loader.propTypes = {
  isLarge: PropTypes.bool,
  className: PropTypes.string,
  wrapperClass: PropTypes.string,
};

export default Loader;
